// extracted by mini-css-extract-plugin
module.exports = {"input":"SignInTextInput_input__2wX79","inputText":"SignInTextInput_inputText__2JSAp","error":"SignInTextInput_error__hyGdf"};